'use strict'

const cardType = require('credit-card-type')
const regSpaces = /\s/g
function cardInputChange(){
	let val = this.value.replace(regSpaces, '')
	const type = cardType(val)
	if(val && type.length){
		this.className = `cc-${type[0].type}`
		if(type[0].gaps && type[0].gaps.length){
			val = prettyCardNumber(val, type[0].gaps)
		}
		this.value = val
	}
	else{
		this.className = ''
	}
}
function prettyCardNumber(cardNumber, gaps) {
	let offsets = [0].concat(gaps).concat([cardNumber.length])
	let components = []
	for(var i = 0; offsets[i] < cardNumber.length; i++){
		let start = offsets[i]
		let end = Math.min(offsets[i + 1], cardNumber.length)
		components.push(cardNumber.substring(start, end))
	}
	components = components.join(' ')
	return components
}


module.exports = cb => {
	// Credit card input
	const cardInputs = document.querySelectorAll('input[autocomplete="cc-number"]:not([data-cc-processed])')
	for(let i = cardInputs.length; i--;){
		cardInputs[i].dataset.ccProcessed = true
		cardInputs[i].addEventListener('keyup', cardInputChange)
		cardInputs[i].addEventListener('change', cardInputChange)
		cardInputChange.call(cardInputs[i])
	}
	if(cb) cb()
}
